module.exports = __webpack_public_path__ + "static/img/shl_news_center_official_selected.2d50258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_news_center_official_selected.png
// module id = SrNZ
// module chunks = 5